import { PlusOutlined } from '@ant-design/icons';
import { Button, Drawer, PageHeader } from 'antd';
import React from 'react';
import { DRAWER_WIDTH } from '../../config/constants';
import ReplaceStrings from '../../config/replaceStrings';
import Routes from '../../config/routes';
import { translations } from '../../config/translations';
import { ActionType, DrawerState, ModuleName } from '../../core/models/enum';
import { authorizeAction } from '../../helpers/CheckPermissionHelper';
import { getNewSubRoute } from '../../helpers/RoutingHelper';
import {
    CodebooksClient,
    SelectOptionVm,
    VerificationVm,
    VerificationsClient
} from '../../utils/api';
import VerificationForm from './verification-form';
import { Props } from './index';
import VerificationTable from './verification-table';
import { remove } from '../../helpers/SubmitHelper';

interface State {
    allowCreate: boolean;
    drawerState: DrawerState;
    verifications?: VerificationVm[],
    statuses?: SelectOptionVm[],
    editingVerification?: VerificationVm
}

class Verifications extends React.Component<Props, State> {
    private tableRef: any = React.createRef();

    public constructor(props: Props) {
        super(props);

        const {
            location: { pathname },
        } = window;

        this.state = {
            allowCreate: authorizeAction(
                props.userProfile,
                ModuleName.Verifications,
                ActionType.Create
            ),
            drawerState:
                pathname === Routes.ROUTE_VERIFICATIONS_NEW ? DrawerState.Edit : DrawerState.Closed,
            verifications: []
        };
    }

    public componentDidMount = () => {
        this.getVerifications();
        this.getStatuses();
    };

    private getVerifications = async () => {
        this.setState({
            verifications: await new VerificationsClient().getAll(
                null,
                null,
                undefined,
                null,
                null,
                null,
                null,
                null,
                null
            )
        });
    };

    private getStatuses = async () => {
        this.setState({
            statuses: await new CodebooksClient().getByCodebookName('DocumentItemStatus'),
        });
    };


    private handleDrawerMode = (drawerState: DrawerState, id?: string) => {
        const { history } = this.props;

        this.setState({
            drawerState,
        });

        history.push(
            getNewSubRoute(
                Routes.ROUTE_VERIFICATIONS,
                Routes.ROUTE_VERIFICATIONS,
                Routes.ROUTE_VERIFICATIONS_EDIT,
                Routes.ROUTE_VERIFICATIONS_NEW,
                drawerState
            )
        );
    };

    private handleSuccessCreate = (verification: VerificationVm) => {
        this.handleDrawerMode(DrawerState.Closed);
        this.getVerifications();
    };

    private handleVerificationCreate = () => {
        this.setState({
            editingVerification: undefined
        });

        this.handleDrawerMode(DrawerState.Create);
    }

    private handleVerificationEdit = (id: number) => {
        const {
            history
        } = this.props;

        const { verifications } = this.state;

        this.setState({
            editingVerification: verifications?.find(
                (v: VerificationVm): boolean => v.id === id
            ),
            drawerState: DrawerState.Edit
        })

        history.push(
            Routes.ROUTE_VERIFICATIONS_EDIT.replace(
                ReplaceStrings.ENTITY_ID,
                id.toString()
            )
        );

    };


    private handleVerificationDelete = (id: number) => {
        this.getVerifications();
    };

    public render(): React.ReactElement {
        const { allowCreate, drawerState, verifications, editingVerification } = this.state;
        const { userProfile } = this.props;

        return (
            <>
                <PageHeader
                    title={translations.verifications.verifications}
                    extra={
                        allowCreate
                            ? [
                                <Button
                                    key="1"
                                    type="primary"
                                    style={{
                                        zIndex: 10,
                                        float: 'right',
                                    }}
                                    onClick={() => this.handleVerificationCreate()}
                                    className="no-print"
                                >
                                    <PlusOutlined />
                                    {translations.verifications.add}
                                </Button>,
                            ]
                            : []
                    }
                />

                <VerificationTable
                    wrappedComponentRef={this.tableRef}
                    userProfile={userProfile}
                    verifications={verifications}
                    onUpdate={(id: number) => this.handleVerificationEdit(id)}
                    onDelete={(id: number) =>
                        remove(
                            new VerificationsClient(),
                            translations.verifications.deleteSuccess,
                            this.handleVerificationDelete,
                            id
                        )
                    }
                />

                <Drawer
                    title={
                        drawerState === DrawerState.Create
                            ? translations.verifications.add
                            : translations.verifications.edit
                    }
                    open={!!drawerState}
                    onClose={() => this.handleDrawerMode(DrawerState.Closed)}
                    width={DRAWER_WIDTH}
                    destroyOnClose
                >

                    <VerificationForm
                        onClose={() => this.handleDrawerMode(DrawerState.Closed)}
                        onSuccess={this.handleSuccessCreate}
                        verification={editingVerification}
                    />
                </Drawer>
            </>
        );
    }
}

export default Verifications;
